// src/Api/contactInfoApi.js
import axiosClient from "./axiosClient";

// --- Contact Info APIs ---
export const getContactInfos = () => axiosClient.get("/office-info");

export const createContactInfo = (infoData) =>
  axiosClient.post("/office-info", infoData);

export const updateContactInfo = (id, infoData) =>
  axiosClient.put(`/office-info/${id}`, infoData);

export const deleteContactInfo = (id) =>
  axiosClient.delete(`/office-info/${id}`);
